import { Tabs, TabsProps } from "antd";
import React, { FC } from "react";
import { FoundersProps } from "../../../../interfaces/props/FoundersProps";
import { Individuals } from "./Individuals/Individuals";
import { LegalEntities } from "./LegalEntities/LegalEntities";

import classes from './Founders.module.css';

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Физические лица",
    children: <Individuals />,
  },
  {
    key: "2",
    label: "Юридические лица",
    children: <LegalEntities />,
  },
];

export const Founders: FC<FoundersProps> = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} size="large" className={classes.foundersTabs}/>
    </div>
  );
};
